//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import LocaleSwitcher from "@/components/LocaleSwitcher";
import AuthService from "@/services/AuthService";
import AppMenu from "./menu";
import { mapActions, mapState } from "vuex";
import logger from "@/utils/logger";

export default {
  name: "Menu",
  props: ["title"],
  components: { AppMenu: AppMenu },

  data() {
    return {
      darkMode: false,
      auth: null,
      leftDrawerOpen: true,
      webVersion: "",
      apiVersion: ""
    };
  },
  created: function() {
    this.initAuthService();
  },

  watch: {
    lastFileImportTime(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.triggerAvareIconAnimation();
    }
  },

  computed: {
    ...mapState("main", ["user", "appVersion", "up", "lastFileImportTime"])
  },
  methods: {
    async initAuthService() {
      this.auth = await AuthService.create();

      var version = await this.getAvareVersion();

      logger.log(version);

      this.apiVersion = version.api;
      this.webVersion = version.web;
    },

    login() {
      this.auth.login();
    },
    logout() {
      this.auth.logout();
    },
    silentRenew() {
      this.auth.silentRenew();
    },
    async getUser() {
      await this.auth.getUser();
    },
    async getToken() {
      await this.auth.getAccessToken();
    },
    toggleDarkMode() {
      this.$q.dark.set(this.darkMode);
    },
    ToggleLeftDrawerOpen() {
      this.leftDrawerOpen = !this.leftDrawerOpen;
    },
    triggerAvareIconAnimation() {
      const el = this.$refs.avareIcon;
      el.classList.remove("animate-avare-icon");
      void el.offsetWidth;
      el.classList.add("animate-avare-icon");
    },
    ...mapActions("main", ["getAvareVersion"])
  }
};
